import React, { useState } from 'react';
import './style.scss';
import '../style.scss';

import { Checkbox, Modal } from 'antd';
import step1 from "assets/imgs/QrCodeMyVNPT/payment-guide-step-1.png";
import step2 from "assets/imgs/QrCodeMyVNPT/payment-guide-step-2.png";
import shield from "assets/imgs/QrCodeMyVNPT/shield.png";

const PaymentGuide = ({isModal, bankCode, openMobileApp = () => {}}) => {
  const [isChecked, setIsChecked] = useState(true);

  const handleOpenApp = () => {
    localStorage.setItem('checkDisplayModal', isChecked);
    openMobileApp(bankCode)
  }

  return (
    <Modal
      className="qr-code__modal-custom"
      title={null}
      footer={null}
      closable={null}
      open={isModal}
    >
      <div className="qr-code-modal-payment-guide">
        <div className="modal-payment-guide-title">Hướng dẫn thanh toán</div>
        <div className="modal-payment-guide-step">
          <div className="payment-guide-step-title">
            <strong>Bước 1:</strong> Mở tính năng <strong>“Quét mã QR"</strong> trên ứng dụng ngân hàng của bạn.
          </div>
          <img src={step1} alt="" />
        </div>
        <div className="modal-payment-guide-step">
          <div className="payment-guide-step-title">
            <strong>Bước 2:</strong> Bấm <strong>“Chọn mã QR từ thư viện ảnh"</strong> và dùng mã vừa được tải xuống
          </div>
          <img src={step2} alt="" />
        </div>
        
        <div className="modal-payment-guide-footer">
          <Checkbox checked={isChecked} onChange={(e) => setIsChecked(e.target.checked)}>Không hiển thị lại</Checkbox>
          <button className="qr-code__btn-custom" onClick={handleOpenApp}>
            Tiếp tục
          </button>
        </div>
        
        <div className="modal-payment-guide-security">
          <img src={shield} alt="" />
          <span>Mọi giao dịch được bảo mật tuyệt đối</span>
        </div>
      </div>
    </Modal>
  );
}

export default React.memo(PaymentGuide);
